import React, { useState } from 'react';
import type { FC } from 'react';
import { Box, ConfirmInput, Text } from '@wix/cli-ui-kit';
import { useTranslation } from '@wix/cli-i18n';
import { useCreateAppBi } from '../bi/useCreateAppBi.js';

interface ConfirmPackagePathProps {
  path: string;
  onSubmit: (confirmation: boolean) => void;
}

export const ConfirmPackagePath: FC<ConfirmPackagePathProps> = ({
  path,
  onSubmit,
}) => {
  const { t } = useTranslation();
  const { cliFlowStepAnswered } = useCreateAppBi();
  const [cancelled, setCancelled] = useState<boolean>(false);

  return (
    <>
      <Box marginLeft={-2} marginBottom={1}>
        <ConfirmInput
          label={t('create_app.confirm_path_message', {
            path,
          })}
          initialValue={true}
          onSubmit={(confirmation) => {
            cliFlowStepAnswered({
              question: t('create_app.confirm_path.title'),
              questionKey: 'create_app.confirm_path.title',
              answer: String(confirmation),
            });

            onSubmit(confirmation);

            if (!confirmation) {
              setCancelled(true);
            }
          }}
        />
      </Box>
      {cancelled && (
        <Box marginBottom={1}>
          <Text>{t('create_app.confirm_path_exit_message')}</Text>
        </Box>
      )}
    </>
  );
};
